import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormBuilder, FormArray, Validators } from '@angular/forms';
import { NotificationsService } from 'angular2-notifications';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { FeeColumnFilterPanelService } from '../../../../../../services/fee-column-filter-panel.service';
import { QuestionServiceService } from '../../../../../../services/question-service.service';
import { StorageUtil } from '../../../../../../store';


@Component({
  selector: 'app-tryout-edit-standard',
  templateUrl: './tryout-edit-standard.component.html',
  styleUrls: ['./tryout-edit-standard.component.css']
})
export class TryoutEditStandardComponent implements OnInit {
  @Input() ClubProgramQuestionID: number;
  @Output() getQuestionsEvent = new EventEmitter();
  @Output() closeSideOverlayEvent = new EventEmitter();

  public questionForm: FormGroup;
  public OptionArray: FormArray;
  public CustomQuestionTypes: any[];
  public routeParams;
  public validationMessages = {};
  public alphaNumericPattern: RegExp;
  public alphaDashRegex: RegExp;
  public alphaDashSpaceRegex: RegExp;
  public alphaRegex: RegExp;
  public alphaNumericRegex: RegExp;

  public questionType: number;
  public isRequiredQuestion: boolean;
  public required: string;

  constructor(private fb: FormBuilder,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private notificationsService: NotificationsService,
    private spinnerService: Ng4LoadingSpinnerService,
    private feeColumnFilterPanelService: FeeColumnFilterPanelService,
    private questionServiceService: QuestionServiceService) {

    this.alphaNumericPattern = /^[a-zA-Z0-9_ ]+$/;
    this.alphaDashRegex = /^[a-z0-9_\-]+$/i;
    this.alphaDashSpaceRegex = /^[a-z0-9_ \-]+$/i;
    this.alphaRegex = /^[a-z]+$/i;
    this.alphaNumericRegex = /^[a-z0-9]+$/i;

    this.isRequiredQuestion = false;

    this.CustomQuestionTypes = [
      { 'key': '1', 'value': 'Multiple Choice' },
      { 'key': '2', 'value': 'Single Choice' },
      { 'key': '3', 'value': 'Dropdown' },
      { 'key': '4', 'value': 'Short Text Entry (50 max characters)' },
      { 'key': '5', 'value': 'Long Text Entry (500 max characters)' },
      //{ 'key': '6', 'value': 'Standard Pre Set Question' },
    ];

    this.validationMessages = {
      'Required': 'This field is required.',
      'Alpha': 'This field must only contain alphabetical characters.',
      'AlphaNumeric': 'This field must only contain alpha-numeric characters.',
      'AlphaDash': 'This field must only contain alpha-numeric characters, underscores, and dashes.',
      'AlphaDashSpace': 'This field must only contain alpha-numeric characters, underscores, dashes and space.',
    };
  }

  ngOnInit() {
    this.routeParams = this.activeRoute.snapshot.params;
    console.log("ClubProgramQuestionID(In edit component):", this.ClubProgramQuestionID);
    this.initForm();
    this.getQuestionDetails();
    console.log("questionType:", this.questionType);
  }

  initForm() {
    this.questionForm = this.fb.group({
      //QuestionTypes: ['', [Validators.required]],
      Label: ['', [Validators.required]],
      OptionArray: this.fb.array([]),
      IsRequired: ['', [Validators.required]],
    });
  }

  getQuestionDetails() {
    this.spinnerService.show();
    this.questionServiceService.getCustomQuestionDetails(this.ClubProgramQuestionID).subscribe(rs => {
      this.spinnerService.hide();     
      let arrOption = [];
      for (let i in rs.clubProgramQuestionOptionList) {
        let desc = rs.clubProgramQuestionOptionList[i].description;
        arrOption.push(desc);
      }
      this.questionForm.patchValue({
        //QuestionTypes: rs.clubprogramquestiontypeID,
        Label: rs.label,
        IsRequired: rs.isrequired.toString()
      });
      for (let i = 0; i < arrOption.length; i++) {
        this.createOptionControl(arrOption[i]);
      }
    });
  }

  validateUi() {
    Object.keys(this.questionForm.controls).forEach(field => {
      const control = this.questionForm.get(field);
      control.markAsTouched({ onlySelf: true });
    });
  }
  requiredValidaion(name) {
    const control = this.questionForm.get(name);
    control.setValidators([Validators.required]);
    control.updateValueAndValidity();
  }
  removeValidaion(name) {
    const control = this.questionForm.get(name);
    control.reset();
    control.clearValidators();
    control.updateValueAndValidity();
  }
  //isValidQuestionTypes() {
  //  return this.questionForm.get('QuestionTypes').errors
  //    && (this.questionForm.get('QuestionTypes').touched
  //      || this.questionForm.get('QuestionTypes').dirty);
  //}
  isValidIsRequired() {
    return this.questionForm.get('IsRequired').errors
      && (this.questionForm.get('IsRequired').touched
        || this.questionForm.get('IsRequired').dirty);
  }
  isValidLabel() {
    return this.questionForm.get('Label').errors
      && (this.questionForm.get('Label').touched
        || this.questionForm.get('Label').dirty);
  }
  isValidQuestionLabel() {
    return this.questionForm.get('Label').errors
      && (this.questionForm.get('Label').touched
        || this.questionForm.get('Label').dirty);
  }

  customQuestionTypeChange(event, customQuestionType) {
    event.stopPropagation();
    if (customQuestionType === 1) {
    } else if (customQuestionType === 2) {
    } else if (customQuestionType === 3) {
    } else if (customQuestionType === 4) {
    } else if (customQuestionType === 5) {
    }
  }

  //isQuestionTypeSelected(t) {
  //  if (t === '1' || t === '2' || t === '3' || t === '4' || t === '5') {
  //    return true;
  //  } else {
  //    return false;
  //  }
  //}

  closeSideOverlay() {
    this.clearFormData();
    this.feeColumnFilterPanelService.setToggleFilterColumnsPanel(false);
  }

  getQuestionsRecords(isRequired) {
    this.getQuestionsEvent.emit({ IsRequired: isRequired });
  }

  alertMessage(status, message) {
    const toast = this.notificationsService.success(status, message, {
      timeOut: 3000,
      showProgressBar: true,
      pauseOnHover: false,
      clickToClose: false
    });
  }

  isOptionControl(t) {
    if (t === 1 || t === 2 || t === 3) {
      return true;
    } else {
      return false;
    }
  }

  /* ============================== Create Option ============================== */
  createItem(val: any): FormGroup {
    return this.fb.group({ Option: [val] });
  }
  createOptionControl(value) {
    this.OptionArray = this.questionForm.get('OptionArray') as FormArray;
    this.OptionArray.push(this.createItem(value));
  }
  addOption(event) {
    event.stopPropagation();
    this.createOptionControl('');
  }
  removeOption(event, index: number) {
    event.stopPropagation();
    this.OptionArray.removeAt(index);
  }
  /* ============================== END Create Option ============================== */


  /* ============================== SAVE QUESTION ============================== */
  onSubmit(event, formStatus) {
    event.stopPropagation();

    if ((formStatus === 'VALID') && (this.isRequiredQuestion === false)) {
      const f = this.questionForm.value;
      const QuestionOptionListArray = [];

      let qType = Number(this.questionType);
      if (qType === 1 || qType === 2 || qType === 3) {
        for (const i in f.OptionArray) {
          if (f.OptionArray.hasOwnProperty(i)) {
            const objOption = {
              'description': f.OptionArray[i].Option,
              'addedby': 1,
              'updatedby': 0
            };
            QuestionOptionListArray.push(objOption);
          }
        }
      }

      const obj = {
        ClubProgramID: Number(this.routeParams.id),
        ClubProgramQuestionID: Number(this.ClubProgramQuestionID),
        Label: f.Label,
        IsCustom: 1,
        IsRequired: Number(f.IsRequired),
        ClubProgramQuestionTypeID: this.questionType,
        AddedBy: StorageUtil.userID,
        ClubProgramQuestionOptionList: QuestionOptionListArray,
      };
      console.log(obj);

      event.target.innerHTML = 'Saving <i class="fa fa-spinner fa-spin push-5-r"></i>';
      event.target.disabled = true;
      this.questionServiceService.updateQuestion(obj).subscribe((data: any) => {
        event.target.innerHTML = 'Save';
        event.target.disabled = false;
        if (this.questionForm.value.IsRequired === '1') {
          this.getQuestionsRecords(1);
        } else if (this.questionForm.value.IsRequired === '0') {
          this.getQuestionsRecords(2);
        }
        this.clearFormData();
        this.closeSideOverlayEvent.emit();
        this.alertMessage('success', data.result);
      }, error => {
        this.alertMessage('error', error.statusText);
      });

    } else {
      this.isRequiredQuestion = true;
      this.validateUi();
    }
  }
  onReset(event) {
    event.stopPropagation();
    this.clearFormData();
    this.closeSideOverlayEvent.emit();
    //this.getQuestionDetails(this.ClubProgramQuestionID);
    this.questionType = undefined;
  }
  clearFormData() {
    this.questionForm.reset();
    const t = this.questionType;
    if (t === 1 || t === 2 || t === 3) {
      if (typeof this.OptionArray !== 'undefined') {
        this.clearFormArray(this.OptionArray);
      }
    }
  }
  clearFormArray = (formArray: FormArray) => {
    while (formArray.length !== 0) {
      formArray.removeAt(0);
    }
  }
  /* ============================== END SAVE QUESTION ============================== */

  selectedQuestionType(t) {
    this.questionType = t;
    this.isRequiredQuestion = false;
    //this.clearFormData();
  }
}



// WEBPACK FOOTER //
// ./src/app/tryout/pages/tryout-questions/tryout-read-questions/partial/tryout-edit-standard/tryout-edit-standard.component.ts